import { useMemo, useEffect } from "react";
import LmtLsStore from "@state/stores/side-widgets/LmtLsEventStore";

import { useRootAppStore } from "@hooks";
export default function useLmtLsEventStore() {
	const hub = useRootAppStore().hub;
	const store = useMemo(() => new LmtLsStore(hub), []);
	useEffect(() => {
		store.onInitialize();
		return () => store.onDispose();
	}, []);
	return store;
}
